import React from "react";

const ITEMS = [
    {
        role: "Consultant Média",
        company: "ESV Digital — eSearchVision",
        date: "Juillet 2022 — Aujourd'hui",
        location: "Paris 17ᵉ",
        kind: "Média",
        current: true,
        points: [
            "Pilotage et exécution des stratégies d'acquisition multi-marchés (FR · IT · ES · DE · BE · CH).",
            "Création et optimisation de campagnes SEA &amp; Social Ads sur Google, Microsoft, Meta, LinkedIn, X et TikTok.",
            "Tests A/B continus sur créatives et pages d'atterrissage, recommandations data-driven via GA4 et Looker Studio.",
            "Meetings hebdomadaires clients : reporting, recommandations, pilotage budgétaire.",
        ],
        clients: [
            "Armani Beauty",
            "Valentino Beauty",
            "ICI Formation",
            "Fédération Française de Tennis",
            "ClickandBoat",
            "Colisée",
            "Dentego",
            "Médecins Sans Frontières",
        ],
    },
    {
        role: "Développeur Web Fullstack",
        company: "Groupe SII",
        date: "Décembre 2021 — Mai 2022",
        location: "Paris",
        kind: "Développement",
        points: [
            "Conception d'architectures projet IT — secteurs Aéronautique, Défense, Télécoms et Transport.",
            "Configuration et maintenance de serveurs d'hébergement.",
            "Tests continus, intégration et optimisation de l'expérience utilisateur.",
        ],
    },
    {
        role: "Développeur Web Fullstack",
        company: "Suntech",
        date: "Décembre 2020 — Octobre 2021",
        location: "Full remote",
        kind: "Développement",
        points: [
            "Développement de solutions web complètes (Nelleos, KidsCode, PassTik).",
            "Intégration des maquettes design, optimisation SEO et sécurité.",
            "Front-end e-commerce performant.",
        ],
    },
    {
        role: "Développeur Frontend Junior",
        company: "Pero Group",
        date: "Mai 2019 — Septembre 2020",
        location: "Paris",
        kind: "Développement",
        points: [
            "Développement du site institutionnel CDIJ (Bénin) et écriture des tests unitaires.",
        ],
    },
    {
        role: "Développeur Web — Freelance",
        company: "Indépendant",
        date: "Octobre 2018 — Mars 2019",
        location: "Remote",
        kind: "Développement",
        points: ["Missions clients : Kamgoko, Intram."],
    },
];

export default function Experience() {
    return (
        <section
            id="experiences"
            data-testid="experience-section"
            className="relative py-28 md:py-36 border-t border-[#e8e4dd] bg-white"
        >
            <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                <div className="flex items-end justify-between mb-16">
                    <div>
                        <p className="label-eyebrow mb-5">— 02 / Parcours</p>
                        <h2
                            className="font-serif text-5xl md:text-6xl tracking-tight text-[#0e0e0c]"
                            style={{ fontWeight: 400 }}
                        >
                            Quatre années,{" "}
                            <span className="italic-serif">une trajectoire.</span>
                        </h2>
                    </div>
                    <p className="hidden md:block text-sm text-[#6b6b66] max-w-xs text-right leading-relaxed">
                        Du développement fullstack à la stratégie média —
                        une vision à 360° de la performance digitale.
                    </p>
                </div>

                <ol className="relative">
                    {ITEMS.map((it, idx) => (
                        <li
                            key={idx}
                            data-testid={`exp-item-${idx}`}
                            className="grid grid-cols-1 md:grid-cols-12 gap-8 py-10 border-t border-[#e8e4dd] first:border-t-0"
                        >
                            <div className="md:col-span-3">
                                <p className="text-[13px] text-[#6b6b66] tracking-wide">
                                    {it.date}
                                </p>
                                <p className="text-[13px] text-[#9a9890] mt-1">
                                    {it.location}
                                </p>
                                <span
                                    className={`inline-block mt-4 px-3 py-1 text-[11px] tracking-[0.18em] uppercase rounded-full ${
                                        it.current
                                            ? "bg-[#0e0e0c] text-white"
                                            : "border border-[#d4cfc4] text-[#6b6b66]"
                                    }`}
                                >
                                    {it.kind}
                                </span>
                            </div>
                            <div className="md:col-span-9">
                                <h3
                                    className="font-serif text-3xl md:text-4xl text-[#0e0e0c] tracking-tight"
                                    style={{ fontWeight: 400 }}
                                >
                                    {it.role}
                                </h3>
                                <p className="text-[#6b6b66] mt-2 italic-serif text-xl">
                                    {it.company}
                                </p>
                                <ul className="mt-6 space-y-2.5">
                                    {it.points.map((p, i) => (
                                        <li
                                            key={i}
                                            className="flex gap-4 text-[#2c2c2a] text-[15px] leading-[1.7]"
                                        >
                                            <span className="text-[#9a9890] mt-2 shrink-0">
                                                —
                                            </span>
                                            <span dangerouslySetInnerHTML={{ __html: p }} />
                                        </li>
                                    ))}
                                </ul>
                                {it.clients && (
                                    <div className="mt-7">
                                        <p className="label-eyebrow mb-3">
                                            Clients accompagnés
                                        </p>
                                        <div className="flex flex-wrap gap-x-5 gap-y-1.5">
                                            {it.clients.map((c) => (
                                                <span
                                                    key={c}
                                                    className="font-serif text-lg text-[#0e0e0c]"
                                                >
                                                    {c}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}
